import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getDefaultValue, } from '@zenlayer/zen-design/esm/preset-date-picker';
import { PresetDatePicker, Space } from '@zenlayer/zen-design';
import { dataListener_showUtc } from './index';
import dayjs from '@zenlayer/zen-design/esm/_util/day';
import { adjustDate } from './util';
import { useEffect, useRef, useState } from 'react';
import { RefreshButton } from '@zenlayer/portal-utils';
import '@zenlayer/zen-design/esm/preset-date-picker/style/index.less';
export const getPresetDatePickerDefaultValue = (data, ops) => {
    const showUTCValue = dataListener_showUtc.getValue();
    const { latestTime: propsLatestTime, ...otherOps } = ops || {};
    const latestTime = propsLatestTime ||
        adjustDate({
            showUTC: showUTCValue,
            trim: 'dayEnd',
            returnString: true,
        });
    return getDefaultValue(data, {
        latestTime,
        ...otherOps,
        timeZone: showUTCValue ? 'UTC' : dayjs.tz.guess(),
    });
};
export const ChartPresetDatePicker = (props) => {
    const { datePicker_disabled, datePicker_getPopupContainer, presetDatePickerValue, onPresetDatePickerChange, latestTime: propsLatestTime, pollingInterval, extra, onRefresh, datePickerClassName, datePickerStyle, ...presetDatePickerProps } = props;
    const { fullMinute, earliestTime } = presetDatePickerProps;
    const showUTCValue = dataListener_showUtc.useValueListener();
    const latestTime = propsLatestTime ||
        adjustDate({
            showUTC: showUTCValue,
            trim: 'dayEnd',
            returnString: true,
        });
    const [isRefreshing, setIsRefreshing] = useState(false);
    const Timer = useRef();
    useEffect(() => {
        if (pollingInterval) {
            Timer.current = setInterval(() => {
                onRefresh &&
                    onRefresh(getPresetDatePickerDefaultValue(presetDatePickerValue, {
                        earliestTime,
                        latestTime,
                        fullMinute,
                    }));
            }, pollingInterval);
        }
        return () => {
            clearInterval(Timer.current);
        };
    }, [presetDatePickerValue, pollingInterval]);
    return (_jsxs(Space, { align: "center", block: true, onClick: (e) => {
            e.stopPropagation();
        }, children: [presetDatePickerValue && (_jsx(PresetDatePicker, { size: "s", disabled: datePicker_disabled, getPopupContainer: datePicker_getPopupContainer, timeZone: showUTCValue ? 'UTC' : dayjs.tz.guess(), onTimeZoneChange: (timeZone) => {
                    if (timeZone === 'UTC') {
                        dataListener_showUtc.setValue(true);
                    }
                    else {
                        dataListener_showUtc.setValue(false);
                    }
                }, value: presetDatePickerValue, onChange: onPresetDatePickerChange, latestTime: latestTime, className: datePickerClassName, style: datePickerStyle, ...presetDatePickerProps })), extra, onRefresh && (_jsx(RefreshButton, { loading: isRefreshing, onClick: async () => {
                    setIsRefreshing(true);
                    await onRefresh(getPresetDatePickerDefaultValue(presetDatePickerValue, {
                        earliestTime,
                        latestTime,
                        fullMinute,
                    }));
                    setIsRefreshing(false);
                } }))] }));
};
